import { Component, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { NmbService } from '../../service/nmb.service';
import { QuoteService } from '../../service/quote.service';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ClicknpayService } from '../../service/clicknpay.service';
import { ToastModule } from "primeng/toast";

@Component({
  selector: 'app-clicknpay-lookup',
  standalone: true,
  imports: [CommonModule, ButtonModule, DialogModule, ToastModule],
  templateUrl: './clicknpay-lookup.component.html',
  styleUrl: './clicknpay-lookup.component.scss',
  providers: [MessageService],
})
export class ClicknpayLookupComponent {
    checkoutId!: string;
    visible!: boolean;
    screenWidth: number = 1200;
    response: any;

    message: string = '';
    status: string = '';
    providerRef: string = '';
    loading: boolean = false;
    showResultDialog: boolean = false;

    constructor(
        private messageService: MessageService,
        private route: ActivatedRoute,
        private nmb: NmbService, private clicknpayService: ClicknpayService    ) {}

    ngOnInit(): void {
        this.extractQueryParams()
        this.screenWidth = window.innerWidth;
        window.addEventListener('resize', this.onResize.bind(this));
    }

    extractQueryParams(){
        this.route.queryParams.subscribe(params => {
            this.checkoutId = params['id'];
        });
    }

    onResize(event: Event) {
        this.screenWidth = window.innerWidth;
    }

    replaceUnderscores(value: string): string {
      return value.replace(/_/g, ' ');
    }

    checkStatus() {
        this.response = null;
        this.loading=true;
        this.clicknpayService.getStatus(this.checkoutId).subscribe({
            next: (response) => {
                this.response = response;
                this.loading = false;
            },
            error: (error) => {
                this.showErrorMessage(error.error.message);
                this.loading = false;
            },
        });
    }

    showSuccessMessage(message: string) {
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: message,
            life: 2500,
        });
    }

    showErrorMessage(message: string) {
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: message,
            life: 2500,
        });
    }

    showDialog(): void {
        this.visible = true;
    }

    closeDialog(): void {
        this.visible = false;
    }
}
